/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Bridge_Default_NativeInputs */



/**
* | output |
* | --- |
* | "Off by default — this connector's native tools are the preferred path. Turn it on only to expose its raw API to the assistant." |
*
* @param {Api_Bridge_Default_NativeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const api_bridge_default_native = /** @type {((inputs?: Api_Bridge_Default_NativeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Bridge_Default_NativeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Standardmäßig aus — die nativen Tools dieses Connectors sind der bevorzugte Weg. Nur einschalten, um dem Assistenten die rohe API freizugeben.")
	return /** @type {LocalizedString} */ ("Off by default — this connector's native tools are the preferred path. Turn it on only to expose its raw API to the assistant.")
});